import React, { useState, useRef, useEffect } from 'react';
import TauriSearchDropdown from '../TauriSearchDropdown/TauriSearchDropdown';
import { getData } from '../../visualizations/visualizations';
import config from '../../appURL.json';
import './TauriSearchBox.css';

const TauriSearchBox = () => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [recentSearches, setRecentSearches] = useState(null);
    const [searchConfig, setSearchConfig] = useState(null);
    const [checkboxStates, setCheckboxStates] = useState({
        referenceFiles: true,
        transactions: true,
        help: true
    });

    const [isModalOpen, setIsModalOpen] = useState(false);

    const fetchSearchPrepare = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(config.API_Prepare, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                console.error('Failed to fetch data:', response.status);
                return;
            }

            const data = await response.json();
            setRecentSearches(data.searches);
            setSearchConfig(data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchSearchPrepare();
    }, []);


    const searchBoxRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                searchBoxRef.current &&
                !searchBoxRef.current.contains(event.target) &&
                !isModalOpen // Do not close the dropdown if the modal is open
            ) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isModalOpen]);

    const handleFocus = () => {
        setShowDropdown(true);
    };

    const handleChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleCheckboxChange = (key) => {

        setCheckboxStates((prevStates) => ({
            ...prevStates,
            [key]: !prevStates[key]
        }));
    };

    useEffect(() => {
        if (!showDropdown) {
            // Remove focus from the input when the dropdown is hidden
            inputRef.current?.blur();
        }
    }, [showDropdown]);

    return (
        <div className="tauri-search-box form-control w-100" ref={searchBoxRef}>
            <div className="input-group lg-form form-sm form-1 pl-0 flex-grow-1">
                <span className="input-group-text border-0 bg-white pe-0" id="search-text">
                    <i className="search-icon">
                        <img src={`${process.env.PUBLIC_URL}/Images/symbols--search.svg`} alt="Search Icon" />
                    </i>
                </span>
                <input
                    className="form-control my-0 py-2 border-0"
                    type="text"
                    placeholder="Search"
                    aria-label="Search"
                    onFocus={handleFocus}
                    onChange={handleChange}
                    value={searchTerm}
                    ref={inputRef}
                />
            </div>
            <TauriSearchDropdown
                show={showDropdown}
                searchTerm={searchTerm}
                recentSearches={recentSearches}
                checkboxStates={checkboxStates}
                onCheckboxChange={handleCheckboxChange}
                searchConfig={searchConfig}
                setIsModalOpen={setIsModalOpen}
                setShowDropdown={setShowDropdown}
                fetchSearchPrepare={fetchSearchPrepare}
            />
        </div>
    );
};

export default TauriSearchBox;
